<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-auto">
                <h6>Possible Designation and Duty combinations for {{SiteName}}</h6>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <i (click)="close()" class="bi bi-x-lg cursor-pointer"></i>
            </div>
        </div>
    </div>
    <div class="card-body">
        <!-- <div class="row">
            <div class="col-auto">
                <h6>Possible Designation and Duty combinations for {{SiteName}}</h6>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <i (click)="close()" class="bi bi-x-lg cursor-pointer"></i>
            </div>
        </div>
        <hr> -->
        <div>
            <table id="comboTable" class="customeDatatable table table-bordered" style="width:100%"></table>
        </div>
    </div>
    <!-- <div class="card-footer">
        <div class="row">
            <div class="col">
            </div>
            <div class="col-auto">
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="close()"
                        [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div> -->
</div>